import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-utility-header',
  standalone: false,
  templateUrl: './utility-header.component.html',
  styleUrl: './utility-header.component.scss',
})
export class UtilityHeaderComponent {
  @Input() title: string = '';
  @Input() hideBackButton: boolean = false;
  @Input() utilityName: string | undefined = undefined;
  @Output() backButtonClicked = new EventEmitter<void>();

  handleBackButtonClicked() {
    this.backButtonClicked.emit();
  }
}
